import Vue from 'vue';
import Autocomplete from 'v-autocomplete';

import App from './App.vue';

import router from './router';

import store from './store';

const VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false;

Vue.use(Autocomplete);

// domyślne ustawienia scrollowania
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 800,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app');
